/**
 * Download the blank workbook template (T7.41, design.md § 10a, 7.10).
 *
 * `GET /workbook-template` is not blueprint-scoped and returns the same bytes
 * for every signed-in user: a blank plan with canonical headers and one example
 * row per sheet, generated from the exporter's own constants.
 *
 * **The wording is the whole point of this component.** It sits beside the
 * upload control, a few centimetres from "Download Excel", which exports THIS
 * blueprint. Those two are easy to confuse and the consequence of confusing
 * them is someone starting a new plan by overwriting a real one — so this says
 * "blank", says "to start a new plan from", and says what it is not.
 */
import { useState } from 'react';
import { ApiError, downloadFile } from '../../lib/api';
import { useTerms } from '../../lib/terms';

export function TemplateButton() {
  const terms = useTerms();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const run = async () => {
    setBusy(true);
    setError(null);
    try {
      await downloadFile('/workbook-template', 'blueprint-workbook-template.xlsx');
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'The download failed. Try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <span className="bp-action">
      <button
        type="button"
        className="btn"
        onClick={run}
        disabled={busy}
        title={`A blank workbook to start a new plan from. It is not an export of this ${terms.noun('blueprint').toLowerCase()}.`}
      >
        {busy ? 'Preparing…' : 'Download blank template'}
      </button>
      {error ? (
        <span className="bp-inline-err" role="alert">
          {error}
        </span>
      ) : null}
    </span>
  );
}
